// Event types
export const OPENED = 'opened';
export const FAILED = 'failed';
export const COMPLAINT = 'complaint';
export const DELIVERED = 'delivered';
export const ACCEPTED = 'accepted';
